import BodyPartLibrary from "./BodyPartLibrary.js";
import AccessoryLibrary from "./AccessoryLibrary";

import { BPID } from "@/enums/BodyPartIdEnum.js";
import { AID } from '@/enums/AccessoryIdEnum.js';

//Builds the buddy svg from the separate svg components.
//BodyParts are the actual svg elements, BodyPartData is the object that contains the information for placement, size and parent/child connections of body parts

//Constants for buddy body part inheritance, locations and pivot points
//locations are currently relative to parent's pivot point. Might be silly.
const buddyConstants = {
    scale: 1,
    bodyData: [
        {
            id: BPID.MIDDLE,
            position: [ 0.5, 0.51 ],
            relativeToCenter: false,
            transformOrigin: "center center",
            scale: [ 1, 1 ],
            zIndex: 10,
            kind: 'body',
            childParts: [
                {
                    id: BPID.ARM_LEFT,
                    position: [ 0.1, 0.19 ],
                    relativeToCenter: true,
                    transformOrigin: "top right",
                    scale: [ -1, 1 ],
                    zIndex: 4,
                    kind: 'body',
                    childParts: [
                        {
                            id: AID.SLEEVE_LEFT,
                            position: [ 0.08, 0.1 ],
                            relativeToCenter: true,
                            transformOrigin: "center right",
                            scale: [ -1, 1 ],
                            zIndex: 1,
                            kind: 'accessory',
                        },
                        {
                            id: AID.HAND,
                            position: [ 0.08, 0.13 ],
                            relativeToCenter: true,
                            transformOrigin: "center right",
                            scale: [ -1, 1 ],
                            zIndex: 1,
                            kind: 'accessory',
                        },
                    ],
                },
                {
                    id: BPID.ARM_RIGHT,
                    position: [ 0.335, 0.19 ],
                    relativeToCenter: true,
                    transformOrigin: "top left",
                    scale: [ 1, 1 ],
                    zIndex: 3,
                    kind: 'body',
                    childParts: [
                        {
                            id: AID.SLEEVE_RIGHT,
                            position: [ 0.08, 0.1 ],
                            relativeToCenter: true,
                            transformOrigin: "center right",
                            scale: [ 1, 1 ],
                            zIndex: 1,
                            kind: 'accessory',
                        },
                    ]
                },
                {
                    id: BPID.LEG_LEFT,
                    position: [ 0.095, 0.33 ],
                    relativeToCenter: true,
                    transformOrigin: "top center",
                    scale: [ -1, 1 ],
                    zIndex: -1,
                    kind: 'body',
                    childParts: [
                        {
                            id: AID.SHOE_LEFT,
                            position: [ 0.148, 0.115 ],
                            relativeToCenter: true,
                            transformOrigin: "top center",
                            scale: [ -1, 1 ],
                            zIndex: 30,
                            kind: 'accessory',
                        },
                    ],
                },
                {
                    id: BPID.LEG_RIGHT,
                    position: [ 0.335, 0.33 ],
                    relativeToCenter: true,
                    transformOrigin: "top center",
                    scale: [ 1, 1 ],
                    zIndex: -1,
                    kind: 'body',
                    childParts: [
                        {
                            id: AID.SHOE_RIGHT,
                            position: [ 0.148, 0.115 ],
                            relativeToCenter: true,
                            transformOrigin: "top center",
                            scale: [ 1, 1 ],
                            zIndex: 30,
                            kind: 'accessory',
                        },
                    ],
                },
                {
                    id: BPID.TAIL,
                    position: [ 0.290, 0.33 ],
                    relativeToCenter: true,
                    transformOrigin: "top center",
                    scale: [ 1, 1 ],
                    zIndex: -4,
                    kind: 'body',
                },
                {
                    id: BPID.HEAD,
                    position: [ 0.215, -0.11 ],
                    relativeToCenter: true,
                    transformOrigin: "bottom center",
                    scale: [ 1, 1 ],
                    zIndex: 10,
                    kind: 'body',
                    childParts: [
                        {
                            id: BPID.EYES,
                            position: [ 0.18, 0.25 ],
                            relativeToCenter: true,
                            transformOrigin: "center center",
                            scale: [ 1, 1 ],
                            zIndex: 11,
                            kind: 'body',
                            childParts: []
                        },
                        {
                            id: BPID.ANTENNA,
                            position: [ 0.18, 0.25 ],
                            relativeToCenter: true,
                            transformOrigin: "center center",
                            scale: [ 1, 1 ],
                            zIndex: 11,
                            kind: 'body',
                            childParts: []
                        },
                        {
                            id: BPID.SNOUT,
                            position: [ 0.18, 0.25 ],
                            relativeToCenter: true,
                            transformOrigin: "center center",
                            scale: [ 1, 1 ],
                            zIndex: 12,
                            kind: 'body',
                            childParts: []
                        },
                        {
                            id: BPID.WHISKERS,
                            position: [ 0.18, 0.25 ],
                            relativeToCenter: true,
                            transformOrigin: "center center",
                            scale: [ 1, 1 ],
                            zIndex: 11,
                            kind: 'body',
                        },
                        {
                            id: AID.HAT,
                            position: [ 0.18, 0.25 ],
                            relativeToCenter: true,
                            transformOrigin: "center center",
                            scale: [ 1, 1 ],
                            zIndex: 12,
                            kind: 'accessory',
                            childParts: []
                        },
                        {
                            id: BPID.NOSE,
                            position: [ 0.18, 0.25 ],
                            relativeToCenter: true,
                            transformOrigin: "center center",
                            scale: [ 1, 1 ],
                            zIndex: 13,
                            kind: 'body',
                            childParts: []
                        },
                        {
                            id: BPID.MOUTH,
                            position: [ 0.18, 0.25 ],
                            relativeToCenter: true,
                            transformOrigin: "center center",
                            scale: [ 1, 1 ],
                            zIndex: 13,
                            kind: 'body',
                            childParts: []
                        },
                        {
                            id: BPID.EAR_RIGHT,
                            position: [ 0.37, 0.30 ],
                            relativeToCenter: true,
                            transformOrigin: "center center",
                            scale: [ 1, 1 ],
                            zIndex: -1,
                            kind: 'body',
                            childParts: []
                        },
                        {
                            id: BPID.EAR_LEFT,
                            position: [ -0.003, 0.30 ],
                            relativeToCenter: true,
                            transformOrigin: "center center",
                            scale: [ -1, 1 ],
                            zIndex: -1,
                            kind: 'body',
                            childParts: []
                        },
                        {
                            id: BPID.HEAD_FUZZ,
                            position: [ 0.19, 0.25 ],
                            relativeToCenter: true,
                            transformOrigin: "center center",
                            scale: [ 1, 1 ],
                            zIndex: 11,
                            unhealthy: true,
                            kind: 'body',
                            childParts: []
                        },
                        {
                            id: BPID.HEAD_WRINKLES,
                            position: [ 0.18, 0.25 ],
                            relativeToCenter: true,
                            transformOrigin: "center center",
                            scale: [ 1, 1 ],
                            zIndex: 11,
                            unhealthy: true,
                            kind: 'body',
                            childParts: []
                        },
                        {
                            id: BPID.EYEBROW_LEFT,
                            position: [ 0.11, 0.21 ],
                            relativeToCenter: true,
                            transformOrigin: "center center",
                            scale: [ -1, 1 ],
                            zIndex: 11,
                            unhealthy: false,
                            kind: 'body',
                            childParts: []
                        },
                        {
                            id: BPID.EYEBROW_RIGHT,
                            position: [ 0.25, 0.21 ],
                            relativeToCenter: true,
                            transformOrigin: "center center",
                            scale: [ 1, 1 ],
                            zIndex: 11,
                            unhealthy: false,
                            kind: 'body',
                            childParts: []
                        },
                    ]
                },

                {
                    id: AID.SHIRT,
                    position: [ 0.215, 0.2 ],
                    relativeToCenter: true,
                    transformOrigin: "center center",
                    scale: [ 1, 1 ],
                    zIndex: 3,
                    kind: 'accessory',
                    childParts: []
                },
                {
                    id: BPID.BODY_WRINKLES,
                    position: [ 0.215, 0.2 ],
                    relativeToCenter: true,
                    transformOrigin: "center center",
                    scale: [ 1, 1 ],
                    zIndex: 3,
                    unhealthy: true,
                    kind: 'body',
                    childParts: []
                },
                {
                    id: AID.PANTS,
                    position: [ 0.215, 0.20 ],
                    relativeToCenter: true,
                    transformOrigin: "center center",
                    scale: [ 1, 1 ],
                    zIndex: 2,
                    kind: 'accessory',
                    childParts: []
                },


            ]
        }
    ]
}


export default class BuddyBuilder
{

    static buildBuddy(buddyData, windowData, onlyShowHealthy)
    {
        return new Promise((resolve) =>
        {
            let buddyDiv = document.querySelector('#beweeg-buddy-window');

            //for every required body part, get the right version and add it to the correct parent element
            buddyConstants.bodyData.forEach(bodyPartData =>
            {
                if (bodyPartData.kind === 'body')
                {
                    this.setUpBodyPart(buddyData, bodyPartData, windowData, buddyDiv, buddyConstants.scale, onlyShowHealthy).then(function()
                    {
                        resolve(buddyDiv);
                    });
                }
                else if (bodyPartData.kind === 'accessory')
                {
                    this.setUpBodyPart(buddyData, bodyPartData, windowData, buddyDiv, buddyConstants.scale, onlyShowHealthy).then(function()
                    {
                        resolve(buddyDiv);
                    });
                }

            });

        });

    }

    static generateBuddyContainerSVG(windowData)
    {
        let container = document.createElementNS("http://www.w3.org/2000/svg", 'svg');
        container.setAttributeNS(null, "width", windowData.width);
        container.setAttributeNS(null, "height", windowData.height);
        container.setAttributeNS(null, "viewBox", "0 0 " + windowData.width + " " + windowData.height);

        //debug coloring
        container.style.backgroundColor = 'gray';
        container.style.border = '1px red solid';

        return container;
    }

    static setUpBodyPart(buddyData, bodyPartData, windowData, parentNode, scale, onlyShowHealthy)
    {
        return new Promise((resolve) =>
        {
            if ((bodyPartData.unhealthy && !onlyShowHealthy) || !bodyPartData.unhealthy)
            {

                let id = bodyPartData.id;

                //get the custom body part id from buddyData
                let customBodyPartId;
                if (bodyPartData.kind === 'body')
                {
                    customBodyPartId = buddyData.bodyPartIds[id].name;
                }
                else if (bodyPartData.kind === 'accessory')
                {
                    customBodyPartId = buddyData.accessoryIds[id].name;
                    if (customBodyPartId === '')
                    {
                        resolve();
                    }
                }


                let that = this;


                this.generateBodyPart(customBodyPartId, id, bodyPartData, windowData, scale, buddyData.buddyConfig.grade).then(
                    function(bodyPart)
                    {
                        parentNode.appendChild(bodyPart);

                        if (Object.prototype.hasOwnProperty.call(bodyPartData, 'childParts') && bodyPartData.childParts.length > 0)
                        {
                            let completedBodyParts = 0;

                            bodyPartData.childParts.forEach(part =>
                            {
                                //let parentNode = bodyPart.querySelector("." + bodyPartData.id);
                                let parentNode = bodyPart;

                                that.setUpBodyPart(buddyData, part, windowData, parentNode, scale, onlyShowHealthy).then(function()
                                {
                                    completedBodyParts++;
                                    if (completedBodyParts >= bodyPartData.childParts.length)
                                    {
                                        resolve();
                                    }
                                });
                            });
                        }
                        else
                        {
                            resolve();
                        }
                    }
                );
            }
            else
            {
                resolve();
            }
        });

    }

    static async generateBodyPart(customId, bodyPartType, bodyPartData, windowData, scale, grade)
    {
        let that = this;
        //console.log("generating body part " + customId)
        return new Promise((resolve) =>
        {
            if (bodyPartData.kind === 'body')
            {
                BodyPartLibrary.getBodyPartFromFile(customId, grade).then(function(part)
                {
                    //console.log(part);
                    let wrapper = that.setUpWrapperElement(part, bodyPartType, bodyPartData, windowData, scale);
                    resolve(wrapper);
                });
            }
            else if (bodyPartData.kind === 'accessory')
            {
                AccessoryLibrary.getAccessoryFromFile(customId, grade).then(function(part)
                {
                    let wrapper = that.setUpWrapperElement(part, bodyPartType, bodyPartData, windowData, scale);
                    resolve(wrapper);
                });
            }


        });

    }

    static setUpWrapperElement(part, bodyPartType, bodyPartData, windowData, scale)
    {
        let el = document.createElement('svg');
        let viewBox = [ 0, 0, 0 ];

        /*
        if(bodyPartData.unhealthy) {
            el.style.display = "none";
        }

         */

        if (part.svg)
        {
            el = part.svg;
            viewBox = el.getAttribute("viewBox").split(" ");

        }
        else
        {
            //console.log("part svg not found");
        }

        let elWidth = viewBox[2] * scale;
        let elHeight = viewBox[3] * scale;

        el.style.width = elWidth;
        el.style.height = elHeight; //is this necessary? It should always scale according to aspect ratio anyway

        let wrapper = document.createElement('div');
        wrapper.classList.add("bodypartWrapper");
        wrapper.classList.add(bodyPartType);
        wrapper.style.width = elWidth + "px";
        wrapper.style.height = elHeight + "px";
        wrapper.style.transformOrigin = bodyPartData.transformOrigin;
        wrapper.style.zIndex = bodyPartData.zIndex;

        if (bodyPartData.relativeToCenter)
        {
            wrapper.style.top = ((windowData.height * bodyPartData.position[1]) - elHeight / 2) + "px";
            wrapper.style.left = ((windowData.width * bodyPartData.position[0])) - elWidth / 2 + "px";
        }
        else
        {
            wrapper.style.top = (windowData.height * bodyPartData.position[1]) - elHeight / 2 + "px";
            wrapper.style.left = ((windowData.width * bodyPartData.position[0])) - elWidth / 2 + "px";
        }

        //el.style.transformOrigin = bodyPartData.transformOrigin;
        el.style.zIndex = bodyPartData.zIndex;
        el.style.transform = "scale(" + bodyPartData.scale[0] + "," + bodyPartData.scale[1] + ")";

        wrapper.appendChild(el);

        return wrapper;
    }

    static htmlToElement(html)
    {
        let template = document.createElement('template');
        template.innerHTML = html;
        return template.content.firstChild;
    }

    static findBodyPartDataById(bodyPartCollection, id)
    {
        let result = null;
        bodyPartCollection.forEach(bodyPartData =>
        {
            if (bodyPartData.id === id)
            {
                result = bodyPartData;
            }
            else
            {
                if (Object.prototype.hasOwnProperty.call(bodyPartData, 'childParts'))
                {
                    result = this.findBodyPartDataById(bodyPartData.childParts, id);
                }
            }

        });

        return result;
    }
}
